import { componentProvider } from 'js-component-framework';
import DatePicker from './DatePicker';
import './date-picker.scss';

const datePickerConfig = {
  name: 'date-picker',
  component: DatePicker,
  querySelector: {
    field: '[data-pikaday-input]',
    trigger: 'button',
    container: '[data-pikaday-container]',
  },
  options: {
    format: 'MM/DD/YYYY',
    bound: false,
    defaultDate: false,
    setDefaultDate: true,
    maxDate: new Date(),
    showDaysInNextAndPreviousMonths: true,
    blurFieldOnSelect: false,
  },
};

componentProvider(datePickerConfig);
